export const NAME_SEPARATOR = '-';
export const NAME_PREFIX = `sale${NAME_SEPARATOR}block`;

export default {
  NAME_SEPARATOR,
  NAME_PREFIX,
};
